import { Slugs } from 'common/urls/Slugs';
import { isEmpty, isNull, map } from 'lodash';
import { useState } from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import { Link } from 'react-router-dom';
import noPreviousOrdersImg from 'src/assets/svg/order/illo-shef.svg';
import { usePreviousGroupOrdersQuery } from 'src/gqlReactTypings.generated.d';
import { ConsumerGroupOrderRatingModalContainer } from 'src/pages/components/ratings/ConsumerGroupOrderRatingModal/ConsumerGroupOrderRatingModalContainer';
import { PrimaryButton } from 'src/shared/design-system/Buttons';
import { Loading } from 'src/shared/design-system/Loading';
import { Routes } from 'src/shared/Routes';
import { getSluggedPath } from 'src/shared/utils/RouteUtilities';
import { useUserPreferences } from 'src/user-preferences/useUserPreferences';
import { ConsumerOrdersCard } from './ConsumerOrdersCard';
import { EmptyOrdersContainer, OrdersListTitle } from './styles';
import { TabNames } from './utilities';

export const PreviousOrdersTab = () => {
  const [{ zipcode: cachedZipCode }] = useUserPreferences();
  const [ratingModalGroupOrderId, setRatingModalGroupOrderId] = useState<string | null>(null);

  const { data, loading, fetchMore } = usePreviousGroupOrdersQuery({ fetchPolicy: 'cache-and-network' });
  if (loading || !data) {
    return <Loading />;
  }

  const { edges, pageInfo } = data.previousGroupOrders;
  if (isEmpty(edges)) {
    const path = isNull(cachedZipCode)
      ? Routes.CONSUMER_LANDING
      : getSluggedPath(Routes.CONSUMER_EXPLORE, [{ slug: Slugs.ZIP_CODE, value: cachedZipCode }]);

    return (
      <EmptyOrdersContainer>
        <img src={noPreviousOrdersImg} alt='no previous orders' />
        <OrdersListTitle>You have no previous orders.</OrdersListTitle>
        <Link to={path}>
          <PrimaryButton.M.RED>Explore shefs</PrimaryButton.M.RED>
        </Link>
      </EmptyOrdersContainer>
    );
  }

  const groupOrders = map(edges, 'node');
  return (
    <InfiniteScroll
      loader={<Loading />}
      dataLength={groupOrders.length}
      hasMore={pageInfo.hasNextPage}
      style={{ overflowY: 'hidden' }}
      next={() => fetchMore({ variables: { after: pageInfo.endCursor } }).catch(console.error)}>
      {groupOrders.map((groupOrder) => (
        <ConsumerOrdersCard
          groupOrder={groupOrder}
          key={groupOrder.id}
          activeTab={TabNames.PREVIOUS}
          showReviewModal={() => setRatingModalGroupOrderId(groupOrder.id)}
        />
      ))}

      {ratingModalGroupOrderId && (
        <ConsumerGroupOrderRatingModalContainer
          groupOrderId={ratingModalGroupOrderId}
          hide={() => setRatingModalGroupOrderId(null)}
        />
      )}
    </InfiniteScroll>
  );
};
